import React, { useRef } from "react";
import { mobileIs } from "../../../utils/siteUtils";
import Icon from "../../../elements/icon";
import { RichText } from "@sitecore-jss/sitecore-jss-react";

const MediaCollectionItem = props => {
  const { image, imageMobile, title, titleMobile } = props.data
  const imgEl = useRef(null);
  const isMobile = mobileIs();
	const id = props.id
	const handleOnLoaded = () => {
		props.handleOnLoaded(id,imgEl.current.getBoundingClientRect().width)
	}
  return (
		<>
			{ !isMobile && image.value &&
				<img ref={imgEl} className="c-media-collection__rows-img" width={image.value.width} height={image.value.height} src={image.value.src} onLoad={handleOnLoaded} />
			}
			{ isMobile && imageMobile.value &&
				<img ref={imgEl} className="c-media-collection__rows-img" src={imageMobile.value.src} onLoad={handleOnLoaded} />
			}
			<div className="c-media-collection__rows-bottom">
				{ ((isMobile && titleMobile.value) || (!isMobile && title.value)) &&
					<RichText tag="div" className="c-media-collection__rows-title type-h1" field={isMobile ? titleMobile : title} 
				/>}
				<Icon name="RightBoldIcon" className="c-media-collection__rows-icon" />
			</div>
		</>
  )
};
export default MediaCollectionItem;
